import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AppContent from "./AppContent";
import { ThemeProvider, CssBaseline } from "@mui/material";
import modernTheme from "../../theme/modernTheme";

const AppRoot = () => {
  return (
    <ThemeProvider theme={modernTheme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/contact" />
          <Route path="/about" />
          <Route path="*" element={<AppContent />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default AppRoot;
